import { render, staticRenderFns } from "./MaxCreateForm.vue?vue&type=template&id=2258bb1f&scoped=true"
import script from "./MaxCreateForm.vue?vue&type=script&lang=js"
export * from "./MaxCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2258bb1f",
  null
  
)

export default component.exports